<template>
  <div class="home">
    <header>
			<div class="container-fluid">
					<div class="row top-blue">
					</div>
			</div>			
		</header>
		
		<main>
			<div class="container">
				<PageHeader/>
				<div class="row">
					<div class="col">
						<form id="course-data-form" @submit="checkForm" v-if="show == 'start'" >
							<section v-if="$route.query.id" id="course-data">
								<h1>{{$t("home.title")}}</h1>
								<p class="intro">
									{{$t("home.part1")}}</p>
                                <p>{{$t("home.part2")}}
								</p>
                                <p>{{$t("home.part3")}}
								</p>
								<small>
									{{$t("home.small")}}
								</small>
                                <br>
                                <br>
                                <p class="errorField" v-if="errors.length">
                                    <b>{{$t("home.errorfield")}}</b>
                                    <ul>
                                    <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
                                    </ul>
                                </p>
								<div class="form-group">
									<label for="firstname">{{$t("home.firstname")}}</label>
									<input type="text" class="form-control" id="firstname"  v-model="firstName">
								</div>
								<div class="form-group">
									<label for="lastname">{{$t("home.lastname")}}</label>
									<input type="text" class="form-control" id="lastname"  v-model="lastName">
								</div>
								<div class="form-group">
									<label for="email">{{$t("home.email")}}</label>
									<input type="email" class="form-control" id="email" aria-describedby="emailHelp"  v-model="email">
									<small id="emailHelp" class="form-text text-muted">{{$t("home.emaildescription")}}</small>
								</div>
								<br />
                                <div class="form-group">
                                    <!--<vue-recaptcha 
                                          ref="recaptcha"
                                          @verify="checkForm"
                                          @expired="onCaptchaExpired"
                                          size="invisible"
                                         sitekey="6Lc8IMUUAAAAAMnN-u2Q9PApJOyRINuOXsMs68Yh" :loadRecaptchaScript="true">-->
                                        <button type="submit" class="btn btn-primary">{{$t("home.submit")}}</button>
                                    <!--</vue-recaptcha>-->
                                </div>
							</section>
                            <section v-if="!$route.query.id">
                                {{$t("invalidurl")}}
                            </section>
						</form>
						<div v-if="show == 'success'" id="success">
							<h1>{{$t("home.successTitle")}} {{firstName}}.</h1>
							<br />
							<div >
								<p>{{$t("home.successDescr1")}}</p>
                                <p>{{$t("home.successDescr2")}}</p>
                                <p>{{$t("home.successDescr3")}}</p>
							</div>
						</div>
                        <div v-if="show == '202'" id="202">
							<h1>{{$t("home.202Title")}} {{firstName}}</h1>
							<br />
							<div >
								<p>{{$t("home.202Descr1")}}</p>
                                <p>{{$t("home.202Descr2")}}</p>
							</div>
						</div>
                        <div v-if="show == '409'" id="202">
							<h1>{{$t("home.409Title")}}</h1>
							<br />
							<div >
								<p>{{$t("home.409Descr1")}}</p>
							</div>
						</div>
                        <div v-if="show == '410'" id="202">
							<h1>{{$t("home.410Title")}}</h1>
							<br />
							<div >
								<p>{{$t("home.410Descr1")}}</p>
							</div>
						</div>
                        <div v-if="show == 'error'" id="error">
							<h1>{{$t("error.title")}}</h1>
							<br />
							<div >
								<p><a href="#" @click="retry">{{$t("error.retry")}}</a> </p>
                                <p>{{$t("error.part2")}} <a href="mailto:dlo@hva.nl">dlo@hva.nl</a></p>
							</div>
						</div>
                        <div v-if="show == 'loading'" id="loading">
							<div >
								<Loading/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
        <footer>
        </footer>
  </div>
</template>

<script>
// @ is an alias to /src
//import Password from 'vue-password-strength-meter';
//import VueRecaptcha from 'vue-recaptcha';
import Loading from '@/components/Loading.vue'
import PageHeader from '@/components/PageHeader.vue';

export default {
    components: {Loading, PageHeader }, //VueRecaptcha

    data: () => ({
        firstName: null,
        lastName: null,
        email: null,
        score: null,
        errors: [],
        show: 'start',
        checkSumbit: false
    }),
    created() {
        if (this.$route.query.lang == null)
            this.$i18n.locale = "nl";
        else
            this.$i18n.locale = this.$route.query.lang;
    },

    methods: {
        checkForm: function (token) {
            var route = "requestaccount"
            if (this.firstName && this.lastName && this.email) {
                this.show = 'loading';
                var model = this;
                    this.$http({
                        method: 'post',
                        url: `${location.protocol}//${location.host}/api/${route}`,
                        withCredentials: true,
                        headers: { 'Content-Type': 'application/json' },
                        data: {
                            FirstName: this.firstName,
                            LastName: this.lastName,
                            Email: this.email,
                            Recaptcha: token,
                            Id: this.$route.query.id,
                            Language: this.$i18n.locale
                        }
                    })
                        .then(function (response) {
                            if (response.status == '202') {
                                model.show = response.status
                            } else {
                                model.show = 'success'
                            }
                        })
                        .catch(function (error) {
                            model.show = 'error'
                             if (error.response.status == '410' || error.response.status == '409') {
                                model.show = error.response.status
                            } 
                        });
                return true;
            }

            this.errors = [];

            if (!this.firstName) {
                this.errors.push('Voornaam');
            }
            if (!this.lastName) {
                this.errors.push('Achternaam');
            }
            if (!this.email) {
                this.errors.push('E-mail');
            }
            if (!this.password) {
                this.errors.push('Wachtwoord');
            }
            
        },
        showScore (score) {
            this.score = score
        },
        retry () {
            this.show = 'start'
        },
        //submit: function (e) {
        //    e.preventDefault();
            //this.$refs.recaptcha.execute();
        //},
        //onCaptchaExpired: function () {
        //    this.$refs.recaptcha.reset();
        //}
    }
}
</script>